export const MuiTextField = (palette) => ({
  root: {
    border: `1px solid ${palette.common.colors.grey6}`,
    borderRadius: 25,
    height: 40,
    padding: '0 10px 0 16px'
  }
});
